import React, { lazy, Suspense } from "react";

const LazyProperty = lazy(() => import("./AddProperty"));
const LazyRequired = lazy(() => import("./AddRequiredProperty"));
const LazyUpdateRent = lazy(() =>
  import("./Update_properties_Agent/EditRentUpdate")
);
const LazyUpdateSell = lazy(() =>
  import("./Update_properties_Agent/EditUpdateProperty")
);
const LazyViewSell = lazy(() =>
  import("./Sell_properties_Agent/EditSellDetail")
);
const LazyPrintSellList = lazy(() =>
  import("./Sell_properties_Agent/PrintSellList")
);
const LazySellList = lazy(() =>
  import("./Sell_properties_Agent/SellListProperty")
);
const LazyRentList = lazy(() =>
  import("./Rent_properties_Agent/RentListProperty")
);
const LazyEditRentDetail = lazy(() =>
  import("./Rent_properties_Agent/EditRentDetail")
);
const LazyPrintRentList = lazy(() =>
  import("./Rent_properties_Agent/PrintRentList")
);
const LazyEditRequired = lazy(() =>
  import("./Required_properties_Agent/EditRequired")
);
const LazyEditRequiredRent = lazy(() =>
  import("./Required_properties_Agent/EditRequiredRent")
);
const LazyListRentRequired = lazy(() =>
  import("./Required_properties_Agent/ListRentRequired")
);
const LazyListRequiredProperty = lazy(() =>
  import("./Required_properties_Agent/ListRequiredProperty")
);
const LazyPrintListRequiredRent = lazy(() =>
  import("./Required_properties_Agent/PrintListRequiredRent")
);
const LazyPrintListRequired = lazy(() =>
  import("./Required_properties_Agent/PrintListRequired")
);
export const AddProperty = () => (
  <Suspense fallback="loading...">
    <LazyProperty />
  </Suspense>
);
export const AddRequiredProperty = () => (
  <Suspense fallback="loading...">
    <LazyRequired />
  </Suspense>
);
export const SellListProperty = () => (
  <Suspense fallback="loading...">
    <LazySellList />
  </Suspense>
);
//
export const EditRentUpdate = () => (
  <Suspense fallback="loading...">
    <LazyUpdateRent />
  </Suspense>
);
export const EditUpdateProperty = () => (
  <Suspense fallback="loading...">
    <LazyUpdateSell />
  </Suspense>
);
export const EditSellDetail = () => (
  <Suspense fallback="loading...">
    <LazyViewSell />
  </Suspense>
);
export const PrintSellList = () => (
  <Suspense fallback="loading...">
    <LazyPrintSellList />
  </Suspense>
);
export const RentListProperty = () => (
  <Suspense fallback="loading...">
    <LazyRentList />
  </Suspense>
);
export const EditRentDetail = () => (
  <Suspense fallback="loading...">
    <LazyEditRentDetail />
  </Suspense>
);
export const PrintRentList = () => (
  <Suspense fallback="loading...">
    <LazyPrintRentList />
  </Suspense>
);
export const EditRequired = () => (
  <Suspense fallback="loading...">
    <LazyEditRequired />
  </Suspense>
);
export const EditRequiredRent = () => (
  <Suspense fallback="loading...">
    <LazyEditRequiredRent />
  </Suspense>
);

export const ListRentRequired = () => (
  <Suspense fallback="loading...">
    <LazyListRentRequired />
  </Suspense>
);
export const ListRequiredProperty = () => (
  <Suspense fallback="loading...">
    <LazyListRequiredProperty />
  </Suspense>
);
export const PrintListRequiredRent = () => (
  <Suspense fallback="loading...">
    <LazyPrintListRequiredRent />
  </Suspense>
);
export const PrintListRequired = () => (
  <Suspense fallback="loading...">
    <LazyPrintListRequired />
  </Suspense>
);
